import { render, staticRenderFns } from "./insurer.vue?vue&type=template&id=6ccf9492&scoped=true&"
import script from "./insurer.vue?vue&type=script&lang=js&"
export * from "./insurer.vue?vue&type=script&lang=js&"
import style0 from "./insurer.vue?vue&type=style&index=0&id=6ccf9492&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ccf9492",
  null
  
)

export default component.exports